import React from "react";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "../../common-elements/breadcrumbs/Breadcrumbs";
import ErrorlogviewInfo from "../../component/reports/error-log-view/ErrorlogviewInfo";

function ErrorlogView() {
  const { t } = useTranslation();
  return (
    <div className="page-body">
      <Breadcrumbs
        mainTitle={t("ErrorView")}
        parent={t("Reports")}
        parentLink={`${process.env.PUBLIC_URL}/reports`}
      />

      <ErrorlogviewInfo />
    </div>
  );
}

export default ErrorlogView;
